import { lazy as o } from "react";
import { bo as s } from "../icons/icons-map.ts.js";
const r = s(o(() => import("./illustration.js"))), e = s(o(() => import("./card-back.js"))), t = s(o(() => import("./card-front.js"))), i = s(o(() => import("./doctors.js"))), n = s(o(() => import("./health-clipboard.js"))), c = s(o(() => import("./health-search.js"))), m = s(o(() => import("./health-team.js"))), p = s(o(() => import("./man-advocate.js"))), d = s(o(() => import("./man-holding-phone.js"))), l = s(o(() => import("./man-money.js"))), y = s(o(() => import("./man-run.js"))), u = s(o(() => import("./man-talking.js"))), g = s(o(() => import("./medic-accompanying-primary.js"))), h = s(o(() => import("./medic-accompanying-secondary.js"))), M = s(o(() => import("./medic-attending-primary.js"))), U = s(o(() => import("./medic-attending-secondary.js"))), S = s(o(() => import("./medic-calendar.js"))), P = s(o(() => import("./medic-clock.js"))), k = s(o(() => import("./medic-crossed-arms-primary.js"))), b = s(o(() => import("./medic-crossed-arms-secondary.js"))), w = s(o(() => import("./medic-error.js"))), f = s(o(() => import("./medic-explaining.js"))), H = s(o(() => import("./medic-happy-primary.js"))), C = s(o(() => import("./medic-happy-secondary.js"))), W = s(o(() => import("./medic-hello-paper-primary.js"))), A = s(o(() => import("./medic-hello-paper-secondary.js"))), v = s(o(() => import("./medic-negative.js"))), R = s(o(() => import("./medic-prepared.js"))), B = s(o(() => import("./medic-ready.js"))), x = s(o(() => import("./medic-screening-primary.js"))), z = s(o(() => import("./medic-screening-secondary.js"))), E = s(o(() => import("./medic-searching-primary.js"))), j = s(o(() => import("./medic-searching-secondary.js"))), T = s(o(() => import("./medic-smiling.js"))), _ = s(o(() => import("./medic-solution.js"))), N = s(o(() => import("./medic-woman-primary.js"))), O = s(o(() => import("./medic-woman-secondary.js"))), q = s(o(() => import("./medic-x-ray.js"))), F = s(o(() => import("./negative.js"))), G = s(o(() => import("./physical-educator.js"))), L = s(o(() => import("./positive.js"))), Z = s(o(() => import("./salad-and-cloud.js"))), D = s(o(() => import("./schedule.js"))), I = s(o(() => import("./support-call.js"))), J = s(o(() => import("./support-help.js"))), Q = s(o(() => import("./support-primary.js"))), X = s(o(() => import("./system.js"))), $ = s(o(() => import("./user-asking.js"))), K = s(o(() => import("./user-book.js"))), V = s(o(() => import("./user-clock.js"))), Y = s(o(() => import("./user-coffee.js"))), oo = s(o(() => import("./user-computer.js"))), so = s(o(() => import("./user-connection.js"))), ao = s(o(() => import("./user-error-primary.js"))), ro = s(o(() => import("./user-forbidden.js"))), eo = s(o(() => import("./user-gym.js"))), to = s(o(() => import("./user-happy-primary.js"))), io = s(o(() => import("./user-happy-secondary.js"))), no = s(o(() => import("./user-hello.js"))), co = s(o(() => import("./user-help.js"))), mo = s(o(() => import("./user-phone-notification.js"))), po = s(o(() => import("./user-phone.js"))), lo = s(o(() => import("./user-phonesignal-alert.js"))), yo = s(o(() => import("./user-phonesignal-error.js"))), uo = s(o(() => import("./user-phonesignal-ok.js"))), go = s(o(() => import("./user-protection.js"))), ho = s(o(() => import("./user-question.js"))), Mo = s(o(() => import("./user-remedy.js"))), Uo = s(o(() => import("./user-responding.js"))), So = s(o(() => import("./user-results-bad.js"))), Po = s(o(() => import("./user-results-good.js"))), ko = s(o(() => import("./user-results.js"))), bo = s(o(() => import("./user-stay.js"))), wo = s(o(() => import("./user-success.js"))), fo = s(o(() => import("./user-system.js"))), Ho = s(o(() => import("./user-wifi.js"))), Co = s(o(() => import("./user-writing.js"))), Wo = s(o(() => import("./user-zen-happy.js"))), Ao = s(o(() => import("./user-zen.js"))), vo = s(o(() => import("./waiting-room.js"))), Ro = s(o(() => import("./woman-breastfeeding.js"))), Bo = s(o(() => import("./woman-browsing.js"))), xo = s(o(() => import("./woman-clock.js"))), zo = s(o(() => import("./woman-health.js"))), Eo = s(o(() => import("./woman-holding-baby.js"))), jo = s(o(() => import("./woman-holding-phone.js"))), To = s(o(() => import("./woman-jumping.js"))), _o = s(o(() => import("./woman-multitasking.js"))), No = s(o(() => import("./woman-phone.js"))), Oo = s(o(() => import("./women-talking.js"))), a = [
  "card-back",
  "card-front",
  "doctors",
  "health-clipboard",
  "health-search",
  "health-team",
  "man-advocate",
  "man-holding-phone",
  "man-money",
  "man-run",
  "man-talking",
  "medic-accompanying-primary",
  "medic-accompanying-secondary",
  "medic-attending-primary",
  "medic-attending-secondary",
  "medic-calendar",
  "medic-clock",
  "medic-crossed-arms-primary",
  "medic-crossed-arms-secondary",
  "medic-error",
  "medic-explaining",
  "medic-happy-primary",
  "medic-happy-secondary",
  "medic-hello-paper-primary",
  "medic-hello-paper-secondary",
  "medic-negative",
  "medic-prepared",
  "medic-ready",
  "medic-screening-primary",
  "medic-screening-secondary",
  "medic-searching-primary",
  "medic-searching-secondary",
  "medic-smiling",
  "medic-solution",
  "medic-woman-primary",
  "medic-woman-secondary",
  "medic-x-ray",
  "negative",
  "physical-educator",
  "positive",
  "salad-and-cloud",
  "schedule",
  "support-call",
  "support-help",
  "support-primary",
  "system",
  "user-asking",
  "user-book",
  "user-clock",
  "user-coffee",
  "user-computer",
  "user-connection",
  "user-error-primary",
  "user-forbidden",
  "user-gym",
  "user-happy-primary",
  "user-happy-secondary",
  "user-hello",
  "user-help",
  "user-phone-notification",
  "user-phone",
  "user-phonesignal-alert",
  "user-phonesignal-error",
  "user-phonesignal-ok",
  "user-protection",
  "user-question",
  "user-remedy",
  "user-responding",
  "user-results-bad",
  "user-results-good",
  "user-results",
  "user-stay",
  "user-success",
  "user-system",
  "user-wifi",
  "user-writing",
  "user-zen-happy",
  "user-zen",
  "waiting-room",
  "woman-breastfeeding",
  "woman-browsing",
  "woman-clock",
  "woman-health",
  "woman-holding-baby",
  "woman-holding-phone",
  "woman-jumping",
  "woman-multitasking",
  "woman-phone",
  "women-talking"
], qo = [...a], Lo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CardBack: e,
  CardFront: t,
  Doctors: i,
  HealthClipboard: n,
  HealthSearch: c,
  HealthTeam: m,
  Illustration: r,
  ManAdvocate: p,
  ManHoldingPhone: d,
  ManMoney: l,
  ManRun: y,
  ManTalking: u,
  MedicAccompanyingPrimary: g,
  MedicAccompanyingSecondary: h,
  MedicAttendingPrimary: M,
  MedicAttendingSecondary: U,
  MedicCalendar: S,
  MedicClock: P,
  MedicCrossedArmsPrimary: k,
  MedicCrossedArmsSecondary: b,
  MedicError: w,
  MedicExplaining: f,
  MedicHappyPrimary: H,
  MedicHappySecondary: C,
  MedicHelloPaperPrimary: W,
  MedicHelloPaperSecondary: A,
  MedicNegative: v,
  MedicPrepared: R,
  MedicReady: B,
  MedicScreeningPrimary: x,
  MedicScreeningSecondary: z,
  MedicSearchingPrimary: E,
  MedicSearchingSecondary: j,
  MedicSmiling: T,
  MedicSolution: _,
  MedicWomanPrimary: N,
  MedicWomanSecondary: O,
  MedicXRay: q,
  Negative: F,
  PhysicalEducator: G,
  Positive: L,
  SaladAndCloud: Z,
  Schedule: D,
  SupportCall: I,
  SupportHelp: J,
  SupportPrimary: Q,
  System: X,
  UserAsking: $,
  UserBook: K,
  UserClock: V,
  UserCoffee: Y,
  UserComputer: oo,
  UserConnection: so,
  UserErrorPrimary: ao,
  UserForbidden: ro,
  UserGym: eo,
  UserHappyPrimary: to,
  UserHappySecondary: io,
  UserHello: no,
  UserHelp: co,
  UserPhone: po,
  UserPhoneNotification: mo,
  UserPhonesignalAlert: lo,
  UserPhonesignalError: yo,
  UserPhonesignalOk: uo,
  UserProtection: go,
  UserQuestion: ho,
  UserRemedy: Mo,
  UserResponding: Uo,
  UserResults: ko,
  UserResultsBad: So,
  UserResultsGood: Po,
  UserStay: bo,
  UserSuccess: wo,
  UserSystem: fo,
  UserWifi: Ho,
  UserWriting: Co,
  UserZen: Ao,
  UserZenHappy: Wo,
  WaitingRoom: vo,
  WomanBreastfeeding: Ro,
  WomanBrowsing: Bo,
  WomanClock: xo,
  WomanHealth: zo,
  WomanHoldingBaby: Eo,
  WomanHoldingPhone: jo,
  WomanJumping: To,
  WomanMultitasking: _o,
  WomanPhone: No,
  WomenTalking: Oo,
  illustrationList: qo,
  illustrationMap: a
}, Symbol.toStringTag, { value: "Module" }));
export {
  Y as $,
  B as A,
  x as B,
  e as C,
  i as D,
  z as E,
  E as F,
  j as G,
  n as H,
  r as I,
  T as J,
  _ as K,
  N as L,
  p as M,
  O as N,
  q as O,
  F as P,
  G as Q,
  L as R,
  Z as S,
  D as T,
  I as U,
  J as V,
  Q as W,
  X,
  $ as Y,
  K as Z,
  V as _,
  a,
  oo as a0,
  so as a1,
  ao as a2,
  ro as a3,
  eo as a4,
  to as a5,
  io as a6,
  no as a7,
  co as a8,
  mo as a9,
  _o as aA,
  No as aB,
  Oo as aC,
  po as aa,
  lo as ab,
  yo as ac,
  uo as ad,
  go as ae,
  ho as af,
  Mo as ag,
  Uo as ah,
  So as ai,
  Po as aj,
  ko as ak,
  bo as al,
  wo as am,
  fo as an,
  Ho as ao,
  Co as ap,
  Wo as aq,
  Ao as ar,
  vo as as,
  Ro as at,
  Bo as au,
  xo as av,
  zo as aw,
  Eo as ax,
  jo as ay,
  To as az,
  qo as b,
  t as c,
  c as d,
  m as e,
  d as f,
  l as g,
  y as h,
  Lo as i,
  u as j,
  g as k,
  h as l,
  M as m,
  U as n,
  S as o,
  P as p,
  k as q,
  b as r,
  w as s,
  f as t,
  H as u,
  C as v,
  W as w,
  A as x,
  v as y,
  R as z
};
//# sourceMappingURL=illustrations-map.ts.js.map
